var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Summary = /** @class */ (function (_super) {
    __extends(Summary, _super);
    function Summary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Summary.prototype.setModifier = function () {
        return this.props.oddsModf ? " rj-yourbet__selections-odds--" + this.props.oddsModf : "";
    };
    Summary.prototype.render = function () {
        var mdfr = this.setModifier();
        return (React.createElement("div", { className: "rj-yourbet__summary rj-yourbet__section" },
            React.createElement("div", { className: "rj-yourbet__summary-selections rj-yourbet__summary-cell" },
                React.createElement("span", { className: "rj-yourbet__selections-txt-1" }, this.props.txt_1),
                " ",
                React.createElement("span", { className: "rj-yourbet__selections-txt-2" }, this.props.txt_2),
                " @ ",
                React.createElement("span", { className: "rj-yourbet__selections-odds" + mdfr }, this.props.odds)),
            React.createElement("div", { className: "rj-yourbet__summary-return rj-yourbet__summary-cell" },
                React.createElement("span", { className: "rj-yourbet__return-label" }, this.props.returnTxt),
                " ",
                React.createElement("span", { className: "rj-yourbet__return-value" }, this.props.returnValue))));
    };
    return Summary;
}(React.Component));
export { Summary };
//# sourceMappingURL=Summary.js.map